'use strict';

export default class ShowController {

  /*@ngInject*/
  constructor($http, $stateParams, $state) {
    this.$http = $http;
    this.$stateParams = $stateParams;
    this.$state = $state;
  }

  $onInit() {
    this.getReport();
  }

  getReport() {
    let id = this.$stateParams.id;
    this.$http.get(`/api/reports/${id}`).then(response => {
      this.report = response.data;
    });
  }

  addComment() {
    if (!this.comment || this.comment === '') {
      return
    }
    this.$http.post(`/api/reports/${this.report._id}/reply`, {content: this.comment}).then(res => {
      this.getReport()
    });
  }

}



// WEBPACK FOOTER //
// ./client/app/main/show/show.controller.js